"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import { getLinkBehavior } from "../../../utils/targetLinkBehavior/getLinkBehavior.js";
import { Analytics } from "../../Analytics/index.js";
import { CostcoBox } from "../../Util/CostcoBox.js";
import "@nxt-costco-com/forge-components";
import { DEFAULT_HEADER_TEXT_ALIGN, DEFAULT_FEATURE_TEXT_ALIGN, DEFAULT_HEADER_TITLE_TEXT_COLOR } from "./constants.js";
import { generateStyles } from "./utils.js";
import "../../Util/GenericImageHandler.js";
import { CardStrip } from "./components/CardStrip.js";
import { ContentGroup } from "./components/ContentGroup.js";
import "./components/styles.js";
import "@nxt-costco-com/forge-design-tokens";
import "../MarketingTypography/index.js";
import { MainContainer, StyledLeftTile, LeftTileContent, StyledRightTile, IconList } from "./styles.js";
function BulletDetailCardView({
  data,
  sx = {},
  dataTestId
}) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n;
  const {
    header_section_config,
    header_section_content,
    feature_section_config,
    feature_section_content,
    top_strip
  } = data;
  const isCardAsLink = data.enable_card_link && ((_a = data.card_link) == null ? void 0 : _a.url) !== "";
  const { target } = getLinkBehavior(
    (_b = data.card_link) == null ? void 0 : _b.external_site,
    (_c = data.card_link) == null ? void 0 : _c.same_tab_domain
  );
  const onClick = () => {
    var _a2, _b2;
    if (isCardAsLink && data.card_link) {
      if (target === "_self") {
        window.location.href = (_a2 = data.card_link) == null ? void 0 : _a2.url;
      } else if (target === "_blank") {
        window.open((_b2 = data.card_link) == null ? void 0 : _b2.url, "_blank");
      }
    }
  };
  const tileContent = [];
  const iconContent = [];
  const otherHeaderContent = [];
  const otherFeatureContent = [];
  feature_section_content == null ? void 0 : feature_section_content.map((content) => {
    if ("feature_icons" in content) {
      iconContent.push(content);
    } else {
      otherFeatureContent.push(content);
    }
  });
  header_section_content == null ? void 0 : header_section_content.map((content) => {
    if ("tile_block" in content) {
      tileContent.push(content);
    } else {
      otherHeaderContent.push(content);
    }
  });
  const leftTileContent = (tileContent2) => tileContent2 == null ? void 0 : tileContent2.map((content, index) => {
    var _a2, _b2, _c2, _d2, _e2;
    return /* @__PURE__ */ jsx(
      ContentGroup,
      {
        backgroundColor: (_a2 = header_section_config == null ? void 0 : header_section_config.header_color) == null ? void 0 : _a2.font_and_background_color,
        primaryColor: ((_c2 = (_b2 = header_section_config == null ? void 0 : header_section_config.header_color) == null ? void 0 : _b2.font_and_background_color) == null ? void 0 : _c2.text_color) || DEFAULT_HEADER_TITLE_TEXT_COLOR,
        secondaryColor: (_e2 = (_d2 = header_section_config == null ? void 0 : header_section_config.header_color) == null ? void 0 : _d2.font_and_background_color) == null ? void 0 : _e2.text_color,
        content,
        isDisableLinks: isCardAsLink
      },
      index
    );
  });
  const rightTileContent = (tileContent2) => tileContent2.map((content, index) => {
    var _a2, _b2, _c2, _d2;
    return /* @__PURE__ */ jsx(
      ContentGroup,
      {
        backgroundColor: (_a2 = feature_section_config.tile_color) == null ? void 0 : _a2.feature_tag_rating_font_and_background_color,
        primaryColor: (_c2 = (_b2 = feature_section_config.tile_color) == null ? void 0 : _b2.primary_font_and_background_color) == null ? void 0 : _c2.text_color,
        secondaryColor: (_d2 = feature_section_config.tile_color) == null ? void 0 : _d2.secondary_font_color,
        content,
        featureConfig: feature_section_config,
        isDisableLinks: isCardAsLink
      },
      index
    );
  });
  return /* @__PURE__ */ jsx(
    Analytics,
    {
      analyticData: {
        adItem: {
          isExternal: (_d = data.card_link) == null ? void 0 : _d.external_site,
          url: (_e = data.card_link) == null ? void 0 : _e.url
        },
        doNotTrack: (_f = data.privacy_toggle) == null ? void 0 : _f.disable_third_party_tracking,
        title: (_g = data.card_link) == null ? void 0 : _g.title
      },
      children: /* @__PURE__ */ jsx(
        MainContainer,
        {
          "data-testid": dataTestId,
          isCardAsLink,
          onClick,
          children: /* @__PURE__ */ jsxs(
            CostcoBox,
            {
              sx: {
                "& .double-swoosh::after": {
                  background: "url(https://mobilecontent.costco.com/staging/resource/img/24w01226/swoosh-double--red.svg) no-repeat"
                },
                "& .swoosh, & .double-swoosh": {
                  position: "relative"
                },
                "& .swoosh::after, & .double-swoosh::after": {
                  background: "url(https://mobilecontent.costco.com/staging/resource/img/24w01226/swoosh-small--red.svg) no-repeat",
                  bottom: "-21px",
                  content: '""',
                  height: "100%",
                  left: "-2px",
                  margin: "auto",
                  position: "absolute",
                  width: "43px"
                },
                "&:hover": {
                  textDecoration: "none"
                },
                borderRadius: "10px",
                display: "flex",
                flexDirection: { md: "row", sm: "column" },
                flexWrap: "wrap",
                maxWidth: "100%",
                overflow: "hidden",
                textDecoration: "none",
                ...sx
              },
              children: [
                /* @__PURE__ */ jsxs(
                  StyledLeftTile,
                  {
                    background: generateStyles(
                      (_h = header_section_config == null ? void 0 : header_section_config.header_color) == null ? void 0 : _h.font_and_background_color
                    ),
                    children: [
                      /* @__PURE__ */ jsx(
                        CardStrip,
                        {
                          backgroundColor: generateStyles(
                            top_strip == null ? void 0 : top_strip.font_and_background_color
                          ),
                          textColor: (_j = (_i = top_strip == null ? void 0 : top_strip.font_and_background_color) == null ? void 0 : _i.text_color) == null ? void 0 : _j.hex,
                          alignment: header_section_config == null ? void 0 : header_section_config.alignment,
                          text: top_strip == null ? void 0 : top_strip.text,
                          isDisableLinks: isCardAsLink
                        }
                      ),
                      /* @__PURE__ */ jsx(
                        LeftTileContent,
                        {
                          sx: {
                            color: (_m = (_l = (_k = header_section_config == null ? void 0 : header_section_config.header_color) == null ? void 0 : _k.font_and_background_color) == null ? void 0 : _l.text_color) == null ? void 0 : _m.hex,
                            textAlign: (header_section_config == null ? void 0 : header_section_config.alignment) || DEFAULT_HEADER_TEXT_ALIGN
                          },
                          children: /* @__PURE__ */ jsxs(
                            CostcoBox,
                            {
                              sx: {
                                alignItems: (header_section_config == null ? void 0 : header_section_config.alignment) || DEFAULT_HEADER_TEXT_ALIGN,
                                padding: "16px"
                              },
                              children: [
                                tileContent.length > 0 && /* @__PURE__ */ jsx("dl", { children: leftTileContent(tileContent) }),
                                leftTileContent(otherHeaderContent)
                              ]
                            }
                          )
                        }
                      )
                    ]
                  }
                ),
                /* @__PURE__ */ jsxs(
                  StyledRightTile,
                  {
                    background: generateStyles(
                      (_n = feature_section_config == null ? void 0 : feature_section_config.tile_color) == null ? void 0 : _n.primary_font_and_background_color
                    ),
                    sx: {
                      textAlign: feature_section_config.alignment || DEFAULT_FEATURE_TEXT_ALIGN
                    },
                    children: [
                      iconContent.length > 0 && /* @__PURE__ */ jsx(IconList, { children: rightTileContent(iconContent) }),
                      rightTileContent(otherFeatureContent)
                    ]
                  }
                )
              ]
            }
          )
        }
      )
    }
  );
}
export {
  BulletDetailCardView
};
